import * as React from "react";
import { OddsModifiers } from "../../../../enums";

export class Summary extends React.Component<{
    txt_1: string | number
    txt_2: string | number
    odds: string
    returnTxt: string
    returnValue: string
    oddsModf?: OddsModifiers | undefined
}, {}> {

    setModifier() {
        return this.props.oddsModf ? ` rj-yourbet__selections-odds--${this.props.oddsModf}` : "";
    }

    render() {
        const mdfr = this.setModifier();
        return (
            <div className="rj-yourbet__summary rj-yourbet__section">
                <div className="rj-yourbet__summary-selections rj-yourbet__summary-cell">
                    <span className="rj-yourbet__selections-txt-1">
                        {this.props.txt_1}
                    </span> <span className="rj-yourbet__selections-txt-2">
                        {this.props.txt_2}
                    </span> @ <span className={`rj-yourbet__selections-odds${mdfr}`}>
                        {this.props.odds}
                    </span>
                </div>
                <div className="rj-yourbet__summary-return rj-yourbet__summary-cell">
                    <span className="rj-yourbet__return-label">
                        {this.props.returnTxt}
                    </span> <span className="rj-yourbet__return-value">
                        {this.props.returnValue}
                    </span>
                </div>
            </div>
        )
    }
}